import { combineReducers } from 'redux'
import listReducer, { listActions } from '@app-store/slices/subscriptions/list'
import oneSubscriptionReducer, { oneSubscriptionActions } from '@app-store/slices/subscriptions/oneSubscription'
import staticEnumsReducer, { staticEnumsActions } from '@app-store/slices/subscriptions/staticEnums'

export const subscriptionReducers = combineReducers({
    list: listReducer,
    oneSubscription: oneSubscriptionReducer,
    staticEnums: staticEnumsReducer
})

export const subscriptionActions = {
    list: listActions,
    oneSubscription: oneSubscriptionActions,
    staticEnums: staticEnumsActions
}
